import React from "react";
import "../css/CuFrontLogo.css";
import { cufrontLogos } from "../../../cufront-assets/logos/Logos";

const CuFrontLogo = () => {
  
  return (
    <div className="cufront-logo">
      <div>Powered by</div>
      <img src={cufrontLogos.cufrontLogo} />
    </div>
  );
};

export default CuFrontLogo;
